module.exports = __webpack_public_path__ + "img/bottomList1_active.bb8d5cfa.svg";